import { Button, Card, Checkbox, IconButton, LinearProgress, Tooltip, Typography } from '@mui/material';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import React, { Component } from 'react'
import { MdDragIndicator } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { AppContext } from '../../../../AppContext';
import ApiRequestService from '../../../../components/ApiRequestService';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { FaCirclePlus } from 'react-icons/fa6';
import SFNoData from '../../../SFComponents/SFNoData';
import SFPublicSkillsLibrary from '../../../SFComponents/SFPublicSkillsLibrary';

class RecommendForPracticeWidget extends Component {

    static contextType = AppContext

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            categories: [],
        }
    }

    componentDidMount() {
        if (this.props.course && this.props.course.course_id) {
            this.getRecomendPracticeCategories()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.course?.course_id !== this.props.course?.course_id) {
            if (this.props.course && this.props.course.course_id) {
                this.getRecomendPracticeCategories()
            }
        }
        if (prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.getRecomendPracticeCategories();
        }
    }

    getRecomendPracticeCategories() {
        this.setState({
            loading: true,
        })
        ApiRequestService({
            method: "POST",
            url: "/getRecommendForPracticeCategories",
            data: {
                courseID: this.props.course.course_id,
                userName: this.props.selectedStudentUserName,
            }
        }).then(res => {
            if (res.data && res.data.data) {
                this.setState({
                    categories: res.data.data,
                })
            } else {
                this.setState({
                    categories: []
                })
            }
        }).catch(err => {
            console.debug("err", err)
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    handlePickCategory = (catIndex) => {
        let cat = {
            ...this.state.categories[catIndex],
            picked: true
        }

        let newCats = [...this.state.categories];
        newCats[catIndex] = cat;
        this.setState({
            categories: newCats,
        })
    }

    handleAddPracticeSet = () => {

    }

    render() {
        console.debug("this.props.selectedStudentUserName", this.props.selectedStudentUserName)
        const { categories, loading } = this.state;

        const {
            selectedCategories, handleAddCategory, handleRemoveCategory
        } = this.context;

        return (
            <Card className='h-100 w-100 position-relative'
                style={{ backgroundColor: '#9e9e9e', position: 'relative' }} sx={{ boxShadow: 3, borderRadius: 2 }}
            >
                <Card className='w-100 position-relative p-3' style={{ backgroundColor: '#fff', height: categories && categories.length ? "100%" : "100%" }} sx={{ boxShadow: 3, borderRadius: 2 }}>
                    {loading ? (
                        <div className='h-100 mt-5 position-relative'>
                            <div className='w-100 position-relative'>
                                <Skeleton className='my-2' count={5} />
                            </div>
                        </div>
                    ) :
                        <div style={{
                            height: '100%'
                        }}>
                            <div className='d-flex justify-content-between'>
                                <Typography fontSize={18} fontWeight={500} className='px-2'>Recommended For Practice
                                    {/* {categories && categories.length ? ` [${categories.length}]` : ""} */}
                                    <div>
                                        <Typography fontSize={12}>
                                            Based on your most recent <span className='cursor-pointer'>
                                                <Tooltip title={
                                                    <Typography fontSize={12} color='#fff'>
                                                        {/* Accuracy Index = (Percent of questions answered correctly) * (mastery level/total number of questions attempted).  The mastery level is the required number of consecutive correct answers for the category */}
                                                        Accuracy % = (No. of questions correct / Total no. of questions attempted) * 100
                                                    </Typography>
                                                } placement="top" arrow>
                                                    <u><strong>accuracy</strong></u>
                                                </Tooltip>
                                            </span> and <span className='cursor-pointer'>
                                                <Tooltip title={
                                                    <Typography fontSize={12} color='#fff'>
                                                        Time per question (in seconds)
                                                    </Typography>
                                                } placement="top" arrow>
                                                    <u><strong>speed</strong></u>
                                                </Tooltip>
                                            </span>
                                        </Typography>
                                    </div>
                                </Typography>

                                <div className='cursor-pointer drag-handle' style={{ cursor: 'move' }}>
                                    <MdDragIndicator fontSize={24} />
                                </div>
                            </div>
                            {categories && categories.length === 0 ?
                                <div className='d-flex flex-column justify-content-center align-items-center'
                                    style={{
                                        height: "80%"
                                    }}>
                                    <SFNoData
                                        title="No Recommendation's yet."
                                        description={`Please start attending ${this.context.isSpecialCourse ? "skills" : "assignments"}, and we will start recommending categories based on your accuracy and speed.`}
                                    />
                                    {this.context.isSpecialCourse ?
                                        <div className='mt-3'>
                                            <SFPublicSkillsLibrary />
                                        </div>
                                        : null}
                                </div>
                                : null}
                            <div className='position-relative w-100 py-3 px-1' style={{
                                height: '85%',
                                overflow: 'auto',
                                // gap: "2rem"
                            }}>
                                {categories && categories.length ? categories.map((cat, index) => {

                                    let catKey = `${cat.subjectID}_${cat.topicID}_${cat.categoryID}`
                                    let catIsAlreadyAdded = false;
                                    if (selectedCategories && selectedCategories.length) {
                                        selectedCategories.forEach(selectedCat => {
                                            if (`${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}` === catKey) {
                                                catIsAlreadyAdded = true;
                                            }
                                        });
                                    }
                                    return (
                                        <div className='d-flex justify-content-start align-items-end w-100 mb-3' key={index} style={{
                                            gap: "16px"
                                        }}>
                                            <div className='w-100'>
                                                <Typography >{cat.label ? cat.label : cat.name}</Typography>
                                                {/* <div className='mb-2 mt-1'>
                                                    <Chip size='small' label={`Accuracy: ${cat.lastAccuracy}%`} />
                                                    <Chip className='ml-2' size='small' label={`Time: ${cat.lastTime}sec`} />
                                                </div> */}
                                                <Typography className='my-1' fontSize={14} fontWeight={600}>Accuracy: {cat.lastAccuracyPercent}%</Typography>
                                                <LinearProgress
                                                    style={{
                                                        height: '13px',
                                                        borderRadius: '7px',
                                                    }}
                                                    color='info'
                                                    variant="determinate"
                                                    value={cat.lastAccuracyPercent}
                                                />
                                            </div>
                                            <div className='pr-3'>
                                                <Tooltip
                                                    title={<Typography color={"#fff"}>
                                                        {catIsAlreadyAdded ? "Remove from Practice Set" : "Add to Practice Set"}
                                                    </Typography>}
                                                    arrow
                                                    placement='top'
                                                >
                                                    <IconButton
                                                        disabled={this.props.selectedStudentUserName && this.props.selectedStudentUserName.length}
                                                        color='primary'
                                                        onClick={() => {
                                                            if (catIsAlreadyAdded) {
                                                                handleRemoveCategory(cat);
                                                            } else {
                                                                handleAddCategory(cat);
                                                            }
                                                            if (this.props.isLTI) {
                                                                let logPayload = {
                                                                    toNomenclatureID: value ? 5 : 6, // 6-unchecked
                                                                    quizID: 0,
                                                                    subjectID: cat.subjectID,
                                                                    topicID: cat.topicID,
                                                                    categoryID: cat.categoryID,
                                                                    activityTypeID: 25, // "Recommended For Practice Tab" activity in p&p page
                                                                };

                                                                if (this.props.onAddActivityLog) {
                                                                    this.props.onAddActivityLog(logPayload)
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {catIsAlreadyAdded ?
                                                            <IoMdCloseCircleOutline />
                                                            :
                                                            <FaCirclePlus />
                                                        }
                                                    </IconButton>
                                                </Tooltip>
                                                {/* <Checkbox
                                                    onChange={(event) => {
                                                        let value = event.target.checked;
                                                        if (value) {
                                                            handleAddCategory(cat);
                                                        } else {
                                                            handleRemoveCategory(cat);
                                                        }
                                                        console.debug("this.props.isLTI", this.props.isLTI)
                                                        if (this.props.isLTI) {
                                                            let logPayload = {
                                                                toNomenclatureID: value ? 5 : 6, // 6-unchecked
                                                                quizID: 0,
                                                                subjectID: cat.subjectID,
                                                                topicID: cat.topicID,
                                                                categoryID: cat.categoryID,
                                                                activityTypeID: 25, // "Recommended For Practice Tab" activity in p&p page
                                                            };

                                                            if (this.props.onAddActivityLog) {
                                                                this.props.onAddActivityLog(logPayload)
                                                            }
                                                        }
                                                    }}
                                                    checked={catIsAlreadyAdded}
                                                    className='sf-checkbox'
                                                /> */}
                                            </div>
                                        </div>
                                    );
                                }) : null}
                            </div>
                        </div>}


                </Card>

                {/* {!loading && categories && categories.length ?
                    <CardActions className='d-flex justify-content-end'>
                        <Link to="/performanceAnalytics">
                            <Button variant='contained' color='primary' className='sf-white-btn'>Go To Practice Page</Button>
                        </Link>
                        <Button variant='contained' color='primary' className='sf-white-btn'
                            onClick={this.handleAddPracticeSet}
                        >Add To Practice Set</Button>
                    </CardActions>
                    : null} */}

            </Card>
        )
    }
}

export default RecommendForPracticeWidget;
